import { FC } from 'react';

export enum LoadingKeys {
  RecalculateLayersHeight = 'recalculate-layers-height',
  Collapse = 'collapse',
  PDFReport = 'PDFReport',
  PagedJS = 'PagedJS',
  ModifiedNodesloading = 'ModifiedNodesloading',
  ExportFullProject = 'ExportFullProject',
}

export interface ISelectOption<V = string | number> {
  label: string;
  value: V;
  icon?: FC<any>;
  disabled?: boolean;
  // Rendered next to the label in a smaller, muted style.
  hint?: string;

  // TODO: refactor interface. Those properties are not used anywhere, only in domains logic.
  type?: string;
  isAutoSelected?: boolean;
}

export const MAX_VISIBLE_CHIP_SYMBOLS = 40;

export const NewItemPrefix = 'new-item-';

export enum OperationsTabs {
  QNOUS_REFERENCE = 'qnous-reference',
  SERVICE_TIERS = 'service-tiers',
}

export enum SupportTabs {
  FAQ = 'faq',
  RELEASE_NOTES = 'release_notes',
}

export const MissingCIAError =
  'The assurance objectives have been added in the settings. Please upload a questionnaire file to \nactivate the Secure-by-Design insight.';

export const InvalidCIAError =
  'The assurance objectives in the settings do not match those in the questionnaire file. Please upload \na new questionnaire file to activate the Secure-by-Design insight.';

export const MissingCIADescription =
  'The assurance objectives have been added in \nthe settings. Please upload a questionnaire \nfile to activate the Secure-by-Design insight.';

export const InvalidCIADescription =
  'The assurance objectives in the settings do \nnot match those in the questionnaire file. \nPlease upload a new questionnaire file to \nactivate the Secure-by-Design insight.';
